// extracted by mini-css-extract-plugin
export default {"container":"initial-loader_container__BFrlK","loaderWrapper":"initial-loader_loaderWrapper__wX6lk"};